import { createContext } from "react";

const BundleFiltersContext = createContext({
  /**
   *  The bundles that are selected in the left navigation filter
   */
  selectedBundles: [],
  /**
   *  Method for updated the selected bundles via checkboxes
   */
  setSelectedBundles: () => {},
  /**
   *  Method for toggling all bundles on/off
   */
  toggleAllBundles: () => {},

  /**
   * The products to display in the navigation and in the main screen while configuring the license, based on the bundle selected.
   *
   * Later this could be set to be based on the bundle and filtered further by the enabled state of the product.
   */
  visibleProducts: [],
  /**
   *  ! Don't use this, set the visible products as a side effect of bundle selection changes
   */
  setVisibleProducts: () => {},

  /**
   * The list of options used to display the bundle filter checkboxes.
   *
   * Use this list to hide or disable options if they are not supported by the current customer segment
   */
  availableBundleOptions: [],
  /**
   * Method for updating the list of available bundle options
   */
  setAvailableBundleOptions: () => {},
});

export default BundleFiltersContext;
